export default __webpack_public_path__ + "static/media/ep6mainVidM.edeeb71f.jpg";